import { cva, type VariantProps } from 'class-variance-authority';
import { LoaderCircle } from 'lucide-react';

import { cn } from '@/lib/utils';

const spinnerVariants = cva('animate-spin text-muted-foreground', {
  variants: {
    size: {
      sm: 'size-3.5',
      default: 'size-4',
      lg: 'size-6',
    },
  },
  defaultVariants: { size: 'default' },
});

export type SpinnerSize = NonNullable<VariantProps<typeof spinnerVariants>['size']>;

export type SpinnerProps = Omit<React.ComponentProps<typeof LoaderCircle>, 'size'> & {
  size?: SpinnerSize;
  /** Announced to screen readers; pass an empty string when a sibling already says it. */
  label?: string;
};

export function Spinner({ className, size, label = 'Cargando', ...props }: SpinnerProps) {
  return (
    <LoaderCircle
      role="status"
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
      className={cn(spinnerVariants({ size }), className)}
      {...props}
    />
  );
}
